export default __webpack_public_path__ + "static/media/logo.0cb8374d.svg";